import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const VerifyEmailPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { verifyEmail } = useAuth();
  
  const [status, setStatus] = useState({
    loading: true,
    success: false,
    message: 'Verifying your email...'
  });

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus({
          loading: false,
          success: false,
          message: 'No verification token provided. Please check your email for the verification link.'
        });
        return;
      }

      try {
        await verifyEmail(token);
        setStatus({
          loading: false,
          success: true,
          message: 'Your email has been verified successfully! You can now log in to your account.'
        });
      } catch (error) {
        setStatus({
          loading: false,
          success: false,
          message: error.message || 'Email verification failed. Please try again or contact support.'
        });
      }
    };

    verify();
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, verifyEmail]);

  return (
    <div className="auth-container">
      <h1>Email Verification</h1>
      
      <div className={`alert alert-${status.loading ? 'info' : (status.success ? 'success' : 'danger')}`}>
        {status.message}
      </div>
      
      {!status.loading && (
        <div className="form-footer">
          {status.success ? (
            <Link to="/login" className="btn">
              Proceed to Login
            </Link>
          ) : (
            <Link to="/login" className="btn">
              Return to Login
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

export default VerifyEmailPage;